import { render } from "./CnafDetails.vue?vue&type=template&id=24559141&scoped=true"
import script from "./CnafDetails.vue?vue&type=script&lang=js"
export * from "./CnafDetails.vue?vue&type=script&lang=js"

import "./CnafDetails.vue?vue&type=style&index=0&id=24559141&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24559141"]])

export default __exports__